import React from "react";

const Navdata = () => {
    const menuItems: any = [
        {
            label: "Admin",
            isHeader: true,
        },
        {
            id: "dashboard",
            label: "Overview",
            icon: "ri-dashboard-2-line",
            link: "/dashboard",
        },
        {
            id: "properties",
            label: "Properties",
            icon: "ri-building-line",
            link: "/properties",
        },
        {
            id: "vendors",
            label: "Vendors",
            icon: "ri-store-2-line",
            link: "/vendors",
        },
        {
            id: "bookings",
            label: "Bookings",
            icon: "ri-calendar-check-line",
            link: "/bookings",
        },
    ];

    return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;
